var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGemLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #144373;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #009444;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #39b54a;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #8dc63f;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #1f8ece;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #0066b3;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 55.35,
    y1: 146.04,
    x2: 452.98,
    y2: 146.04,
    gradientTransform: "translate(0 503.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0093d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#004e88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003e76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 47.02,
    y1: 318.08,
    x2: 452.98,
    y2: 318.08,
    gradientTransform: "translate(0 503.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#31a341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8dc438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2d235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 252.26,
    y1: 238.58,
    x2: 452.78,
    y2: 238.58,
    gradientTransform: "translate(0 503.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0093d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#004e88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003e76"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "390.14 233.62 390.14 328.14 250.01 409.05 118.19 332.94 55.35 369.23 250.01 481.61 250.01 481.61 250.01 481.61 250.01 481.61 452.98 364.41 452.98 358.69 452.98 291.85 452.98 233.62 390.14 233.62 390.14 233.62"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.01 18.39 250.01 18.39 47.02 135.58 47.02 208.14 47.02 208.14 47.02 291.85 47.02 352.75 109.86 316.48 109.86 171.85 250.01 90.94 390.14 171.85 390.14 215.2 452.98 215.2 452.98 208.14 452.98 152.49 452.98 135.58 250.01 18.39 250.01 18.39 250.01 18.39 250.01 18.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "252.26 233.65 252.26 296.49 452.78 296.49 452.78 233.65 252.26 233.65 252.26 233.65"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47.02 352.75 109.86 171.85 109.86 316.48 47.02 352.75 47.02 352.75"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.02 135.58 109.86 171.85 47.02 352.75 47.02 135.58 47.02 135.58"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47.02 135.58 109.86 171.85 250.01 18.39 47.02 135.58 47.02 135.58"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "109.86 171.85 250.01 90.94 250.01 18.39 109.86 171.85 109.86 171.85"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "452.98 215.2 390.14 171.85 390.14 215.2 452.98 215.2 452.98 215.2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "452.98 215.2 452.98 135.58 390.14 171.85 452.98 215.2 452.98 215.2"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "452.98 135.58 250.01 18.39 250.01 90.94 452.98 135.58 452.98 135.58"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "452.98 135.58 250.01 90.94 390.14 171.85 452.98 135.58 452.98 135.58"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.01 481.61 118.19 332.94 55.35 369.23 250.01 481.61 250.01 481.61"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "118.19 332.94 250.01 481.61 250.01 409.05 118.19 332.94 118.19 332.94"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.01 481.61 390.14 328.14 250.01 409.05 250.01 481.61 250.01 481.61"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "250.01 481.61 452.98 364.41 390.14 328.14 250.01 481.61 250.01 481.61"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "390.14 328.14 452.78 233.65 452.98 364.41 390.14 328.14 390.14 328.14"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.14 296.49 390.14 233.65 452.98 233.62 390.14 328.14 390.14 296.49 390.14 296.49"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "252.26 296.49 390.14 233.65 390.14 296.49 252.26 296.49 252.26 296.49"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "252.26 233.65 252.26 296.49 390.14 233.65 252.26 233.65 252.26 233.65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemLogo);
export default __webpack_public_path__ + "static/media/gem_logo.1e8844bc.svg";
export { ForwardRef as ReactComponent };